/**
 * 나 탭 호칭 고치기 (DEV-07z3 8 · D101). 「고치기」를 누르면 그 자리에서 입력칸(10자) → 저장.
 * 서버가 카운터와 같은 이름 뽑기로 「포포라고 불러 주세요」 → 「포포」, 빈 값 · 이름이 아닌 말은 막음. 바꾸면 다음 말부터 새 호칭
 */
import { useState } from 'react';
import { errorMessageOf } from '../../api/client.js';
import * as meApi from '../../api/me.js';
import { useSession } from '../../stores/session.js';

const NAME_MAX_LENGTH = 10;

export function NameEditor({ displayName }) {
    const setUser = useSession((state) => state.setUser);
    const [editing, setEditing] = useState(false);
    const [draft, setDraft] = useState(displayName);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    function open() {
        setDraft(displayName);
        setError(null);
        setEditing(true);
    }

    async function save(event) {
        event.preventDefault();
        if (!draft.trim()) {
            setError('불러 드릴 이름을 적어 주세요.');
            return;
        }
        setSaving(true);
        setError(null);
        try {
            const response = await meApi.updateDisplayName(draft.trim());
            setUser(response.user);
            setEditing(false);
        } catch (failure) {
            setError(errorMessageOf(failure, '호칭을 바꾸지 못했어요. 잠시 후 다시 해 주세요.'));
        } finally {
            setSaving(false);
        }
    }

    if (!editing) {
        return (
            <span className="flex items-center gap-2">
                <span className="text-[17px] font-semibold">{displayName}</span>
                <button
                    type="button"
                    onClick={open}
                    className="text-caption font-semibold text-text-secondary underline-offset-2 hover:underline"
                >
                    호칭 고치기
                </button>
            </span>
        );
    }
    return (
        <form onSubmit={save} className="flex flex-col gap-1.5">
            <span className="flex items-center gap-2">
                <input
                    value={draft}
                    maxLength={NAME_MAX_LENGTH}
                    onChange={(event) => setDraft(event.target.value)}
                    aria-label="호칭"
                    placeholder="이름만 적어 주세요 (예: 포포)"
                    autoFocus
                    className="h-9 min-w-0 flex-1 rounded-lg border border-hairline bg-surface px-2.5 text-[15px]"
                />
                <button
                    type="submit"
                    disabled={saving}
                    className="h-9 shrink-0 rounded-lg bg-brand px-3 text-[14px] font-semibold text-on-brand disabled:opacity-40"
                >
                    저장
                </button>
                <button
                    type="button"
                    onClick={() => setEditing(false)}
                    className="h-9 shrink-0 px-1 text-[14px] text-text-secondary"
                >
                    취소
                </button>
            </span>
            {error ? (
                <span role="alert" className="text-caption text-error">
                    {error}
                </span>
            ) : null}
        </form>
    );
}
